import React from 'react';

import './index.module.less';

import Item from './Item';

interface IProps {
  items: any[] | null;
  onSelectItem: (item : any, isSearch?: boolean) => void;
  selectedLocation: any;
  onShowSearch: () => void;
}

const List = (props: IProps) => {
  const { items, selectedLocation, onSelectItem, onShowSearch } = props;
  const renderLocations = (): (JSX.Element| JSX.Element[]) => {
    let Items = null;
    if(items?.length) {
      Items = items.map((item: any) => {
        return <Item item={ item } onSelect={ onSelectItem } selectItem={ selectedLocation } />
      });
    }else if(items && items.length){
      Items = (
        <div styleName="empty">无结果</div>
      )
    }
    return Items;
  }

  return (
    <div
      className="flex"
      styleName="modal"
      style={{ height: '40%' }}
    >
      <div className="flex" styleName="search-btn-wrapper"  onClick={ onShowSearch }>
        <i className="iconfont icon-sousuo" styleName="input-icon" />
        <div styleName="search-btn">搜索地点名称</div>
      </div>
      <div styleName="list">
        { renderLocations() }
      </div>
    </div>
  )
}

export default List;